"use client";
import React, { useContext, useEffect, useState } from 'react';
import Image from 'next/image';
import "@/scss/_article.scss";
import profileIcon from '../../../public/icons/profile.svg';
import UserContext from '@/context/userContext';
import { getCommentsAPI, saveCommentAPI } from '@/services/followListService';
import { showError, showSuccess } from '@/utils/toast';

const CommentArticleSection = ({ articleId }) => {
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState();
  const [commentAuthor, setCommentAuthor] = useState('');
  const [commentTime, setCommentTime] = useState('');
  const [commentActions, setCommentActions] = useState([]);
  const [commentViewReplies, setCommentViewReplies] = useState([]);
  const [pagination, setPagination] = useState();
  const [isSendingComment, setIsSendingComment] = useState(false);
  const context = useContext(UserContext);
  const user = context.user;
  //console.log('user=>', user);

  // Get Comments
  const getComments = async (page = 1) => {
    try {
      const response = await getCommentsAPI({ articleId, per_page: 2, page });
      if(response.status === 200) {
        if(page === 1) {
          setComments(response.data);
        } else {
          setComments([...comments, ...response.data]);
        }
        setPagination(response.pagination);
      }
    } catch(error){

    }
  }

  // Save Comment
  const saveComment = async () => {
    if(!user){
      showError('Please login to comment on this article');
      return;
    }
    try {
      setIsSendingComment(true);
      const response = await saveCommentAPI({ articleId, commentText });
      if(response.status === 201) {
        setComments([...comments, response.data]);
        setIsSendingComment(false);
        setCommentText('');
        showSuccess(response.message);
      }
    } catch(error){
      setIsSendingComment(false);
    } finally {
      setIsSendingComment(false);
    }
  }
  useEffect(() => {
    if(articleId) {
      if(user){
        getComments();
      }
    }
  }, [articleId]);
  
  return (
    <section className="comments-section">
        <div className="container-fluid  custom-wrapper  article-content-container">
          <h3 className="comments-title">Comments</h3>
          <div className="comment-form mb-4">
            <div className="comment-form-header d-flex align-items-center gap-3 mb-3">
              <div className="comment-avatar">
                <Image src={user?.profile?.profile_picture || profileIcon} alt="User" width={48} height={48} />
              </div>
              <div className="comment-user-name">{user?.name}</div>
            </div>
            <textarea 
              className="comment-input" 
              placeholder="Your Comment..."
              rows="4"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
            ></textarea>
            <button className="btn btn-primary mt-3" onClick={saveComment}>
              {isSendingComment ? 'Sending...' : 'Send'}
            </button>
          </div>

        {/* Comment Section Data — list wrapper so last item can drop border when siblings follow (e.g. View All Replies) */}
        <div className="comment-list">
          {comments.map((commentData, index) => (
            <div key={index} className="comment-item">
              <div className="comment-header d-flex align-items-center gap-3 mb-2">
                <div className="comment-avatar">
                  <Image src={commentData?.user?.profile_picture || profileIcon} alt="User" width={40} height={40} />
                </div>
                <div className="comment-user-name">{commentData?.user?.name}</div>
              </div>
              <p className="comment-text">
                {commentData?.comment}
              </p>
              <div className="comment-footer d-flex justify-content-between align-items-center mt-2">
                <div className="comment-actions">
                  <a href="#" className="comment-action-link">Reply</a>
                  <span className="comment-time">{commentData?.created_at}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        {pagination?.next_page_url && (
                  <div className="comment-view-replies" onClick={() => getComments(pagination?.current_page + 1)}>View All Replies</div>
                )}
        </div>
      </section>
  );
}

export default CommentArticleSection;